<template>
  <div class="ui middle aligned padded grid">
    <div class="ui one wide computer only column"></div>
    <div class="ui six wide tablet only six wide computer only right aligned column">
        <img class="ui right floated image" :src="imageLink"/>
    </div>

    <div class="ui sixteen wide mobile eight wide tablet six wide computer column">
      <h2 class="ui teal header"><slot name="title"/></h2>
      <slot name="body"/>
    </div>

    <div class="ui three wide computer only column"></div>
    <div class="ui sixteen wide mobile only column">
      <center>
        <img class="ui image" :src="imageLink"/>
      </center>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    imageLink: {
      type: String,
      required: false,
      default: () => {
        return 'https://via.placeholder.com/300'
      }
    }
  },
  name: 'FeatureLeft',
  data () {
    return {
    }
  },
  methods: {

  }
}
</script>

<style scoped>

</style>
